import { Formik, FormikProps } from "formik";
import isEqual from "lodash/isEqual";
import { useEffect, useRef, useState } from "react";
import { useMutation } from "react-query";
import * as yup from "yup";
import { PlusIcon } from "..";
import AGButton from "../../../components/Button";
import { CloseIcon } from "../../../components/ComfirmModal/modal.styled";
import AGModal from "../../../components/Modal";
import { useNotification } from "../../../components/Notification";
import { FirmProfile } from "../../../models";
import { httpPUT } from "../../../utils/ajaxHelper";
import { FileBorder, FileLable, FormContainer } from "./cardBackground.styled";
import { isFloat32Array } from "util/types";

export interface AddBackgroundProps {
  visible: boolean;
  toggleModal: () => void;
  data?: FirmProfile;
}
const AddHeaderdModal = ({visible, toggleModal, data}: AddBackgroundProps) => {
  const handleClose = () => {
    toggleModal();
  };
  const formRef = useRef<FormikProps<any>>(null);
  const logoRef = useRef<HTMLInputElement>(null);
  const fileRefBg = useRef<HTMLInputElement>(null);
  const [isDataChanged,setIsDataChanged] = useState<boolean>(false);

  const {showNotification} = useNotification();

  const {mutate: submitForm} = useMutation(
    (data: FormData) =>
      httpPUT({
        url: "/FirmProfile",
        data: data,
      }),
    {
      onSuccess: (rs) => {
        handleClose();
      },
      onError: (rs) => {
        showNotification("Upload Failed", "Error");
      },
    },
  );

  const intitialValues = {
    isDeleteLogo: false,
    isDeletebanner: false,
    fkFirmId: data?.fkFirmId,
    logoName: data?.logoName,
    logoPart: data?.logoPart,
    backgroundName: data?.backgroundName,
    backgroundPart: data?.backgroundPart,
    description: data?.description,
    tagLine: data?.tagLine,
    brochureName: data?.brochureName,
    brochurePath: data?.brochurePath,
    videoUrl: data?.videoUrl,
  }

  if (!data) {
    return null;
  }

  return (
    <div>
      <AGModal
        toggleModal={() => {
          toggleModal();
          formRef.current?.resetForm();
        }}
        title="Organization Header"
        footer={
          <>
            <AGButton
              type="Primary"
              onClick={() => {
                formRef.current?.submitForm();
              }}
              disabled={!isDataChanged}
            >
              Save
            </AGButton>
          </>
        }
        visible={visible}
        setHeight={420}
      >
        <FormContainer>
          <Formik
            innerRef={formRef}
            validationSchema={imageValidationSchema}
            initialValues={
              {
                isDeleteLogo: false,
                isDeletebanner: false,
                fkFirmId: data?.fkFirmId,
                logoName: data?.logoName,
                logoPart: data?.logoPart,
                backgroundName: data?.backgroundName,
                backgroundPart: data?.backgroundPart,
                description: data?.description,
                tagLine: data?.tagLine,
                brochureName: data?.brochureName,
                brochurePath: data?.brochurePath,
                videoUrl: data?.videoUrl,
              } as any
            }
            validateOnChange={true}
            onSubmit={(values: any) => {
              const formData = new FormData();
              formData.append("fkFirmId", values.fkFirmId);
              formData.append("description", values.description ? values.description : "");
              formData.append("tagLine", values.tagLine ? values.tagLine : "");
              formData.append("logo", values.logo);
              formData.append("isDeleteLogo", values.isDeleteLogo);
              formData.append("bg", values.bg);
              formData.append("isDeletebanner", values.isDeletebanner);
              formData.append("videoUrl", values.videoUrl ? values.videoUrl : "");
              submitForm(formData);
            }}
          >
            {({values, setFieldValue, errors}) => {

              const isDirty = !isEqual(
                  { ...values
                  },
                  intitialValues
              );

              setIsDataChanged(isDirty);

              const hasLogoError =
              typeof errors.logo === 'string' ? errors.logo.length > 0 :
                Array.isArray(errors.logo) ? errors.logo.length > 0 :
                false;
              
              const hasBgError =
                typeof errors.bg === 'string' ? errors.bg.length > 0 :
                Array.isArray(errors.bg) ? errors.bg.length > 0 :
                false;
              
              setIsDataChanged(hasLogoError || hasBgError ? false : isDirty);          

              return (
                <form
                  onSubmit={(e) => e.preventDefault()}
                  className="form"
                >
                  <div className="slt">
                    <div className="slt-logo">
                      <label className="label-title text-[14px] text-[#58585B]">Logo:</label>
                      <label className="label-title-second text-[14px]">
                        Please upload an organization logo photo with a minimum size of 150x150px and should
                        not exceed 0.5MB. Image file type must be .jpg,.jpeg,.png,.gif,.webp.
                      </label>
                      <div className="btn-ctn">
                        <FileBorder>
                          <FileLable htmlFor="">
                            <input
                              ref={logoRef}
                              accept="image/*"
                              onChange={(event) => {
                                setFieldValue("isDeleteLogo", false);
                                setFieldValue(
                                  "logo",
                                  event.target.files ? event.target.files[0] : undefined,
                                );
                              }}
                              type="file"
                              style={{display: "none"}}
                            />
                            {!data.logoDisplayName && !values.logo?.name && (
                              <AGButton
                                onClick={() => logoRef.current?.click()}
                                icon={<PlusIcon />}
                                type={"Link"}
                              >
                                Upload logo
                              </AGButton>
                            )}

                            {values.logo?.name && (
                              <div className="flex line-clamp-1">
                                <p className="file-name line-clamp-1">{values.logo.name}</p>
                                <div
                                  className="cont-delete-icon flex"
                                  onClick={() => {
                                    if (logoRef.current && logoRef.current.files) {
                                      logoRef.current.value = "";
                                      setFieldValue("logo", undefined);
                                    }
                                  }}
                                >
                                  <CloseIcon className="delete-icon-brochure">x</CloseIcon>
                                </div>
                              </div>
                            )}
                            {data.logoDisplayName && (
                              <div className="flex line-clamp-1">
                                <p className="file-name line-clamp-1">
                                  {data.logoDisplayName}
                                </p>
                                <div
                                  className="cont-delete-icon flex"
                                  onClick={() => {
                                    data.logoDisplayName = "";
                                    setFieldValue("isDeleteLogo", true);
                                    setFieldValue("logo", undefined);
                                  }}
                                >
                                  <CloseIcon className="delete-icon-brochure">x</CloseIcon>
                                </div>
                              </div>
                            )}
                          </FileLable>
                        </FileBorder>
                        {errors.logo && <div className="error">{errors.logo.toString()}</div>}
                      </div>
                    </div>

                    {/* upload-background */}
                    <div className="slt-bg">
                      <label className="label-title text-[14px] text-[#58585B]">
                        Background photo:
                      </label>
                      <label className="label-title-second text-[14px]">
                        Please upload an organization background photo with a minimum size of 600x200px and
                        should not exceed 2MB. Image file type must be .jpg,.jpeg,.png,.gif,.webp.
                      </label>
                      <div className="btn-ctn">
                        <FileBorder>
                          <FileLable htmlFor="">
                            <input
                              ref={fileRefBg}
                              accept="image/*"
                              onChange={(event) => {
                                setFieldValue("isDeletebanner", false);
                                setFieldValue(
                                  "bg",
                                  event.target.files ? event.target.files[0] : undefined,
                                );
                              }}
                              type="file"
                              style={{display: "none"}}
                            />

                            {!data.bgDisplayName && !values.bg?.name && (
                              <AGButton
                                onClick={() => fileRefBg.current?.click()}
                                icon={<PlusIcon />}
                                type={"Link"}
                              >
                                Upload banner
                              </AGButton>
                            )}

                            {values.bg?.name && (
                              <>
                                <div className="flex line-clamp-1">
                                  <p className="file-name line-clamp-1">{values.bg.name}</p>
                                  <div
                                    className="cont-delete-icon flex"
                                    onClick={() => {
                                      if (fileRefBg.current && fileRefBg.current.files) {
                                        fileRefBg.current.value = "";
                                        setFieldValue("bg", undefined);
                                      }
                                    }}
                                  >
                                    <CloseIcon className="delete-icon-brochure">x</CloseIcon>
                                  </div>
                                </div>
                              </>
                            )}
                            {data.bgDisplayName && (
                              <div className="flex line-clamp-1">
                                <p className="file-name line-clamp-1">
                                  {data.bgDisplayName}
                                </p>
                                <div
                                  className="cont-delete-icon flex"
                                  onClick={() => {
                                    data.bgDisplayName = "";
                                    setFieldValue("isDeletebanner", true);
                                    setFieldValue("bg", undefined);
                                  }}
                                >
                                  <CloseIcon className="delete-icon-brochure">x</CloseIcon>
                                </div>
                              </div>
                            )}
                          </FileLable>
                        </FileBorder>
                        {errors.bg && <div className="error">{errors.bg.toString()}</div>}
                      </div>
                    </div>
                  </div>
                </form>
              );
            }}
          </Formik>
        </FormContainer>
      </AGModal>
    </div>
  );
};
export default AddHeaderdModal;

const getFileExtension = (filename: string): string | null => {
  if (!filename) return null;
  const parts = filename.split(".");
  return parts.length > 1 ? parts.pop()?.toLowerCase() ?? null : null;
};

const validateImageDimensions = async (
  file: File,
  minWidth: number,
  minHeight: number,
): Promise<boolean> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = URL.createObjectURL(file);
    img.onload = () => {
      if (img.width >= minWidth && img.height >= minHeight) {
        resolve(true);
      } else {
        reject(false);
      }
    };
    img.onerror = () => reject(false);
  });
};

export const imageValidationSchema = yup.object({
  logo: yup
    .mixed<any>()
    .notRequired()
    .test("fileType", "Please select an image file.", (value) => {
      if (!value) return true;
      const allowedExtensions = process.env.REACT_APP_IMG_EXT?.split(",").map((ext) =>
        ext.replace(".", "").toLowerCase(),
      );
      const fileExtension = getFileExtension(value.name);
      return allowedExtensions?.includes(fileExtension || "");
    })
    .test("fileSize", "Please select file size less than 0.5MB.", (value) => {
      if (!value) return true;
      return value.size <= +(process.env.REACT_APP_IMG_SIZE_LIMIT || 524288);
    })
    .test("imageDimensions", "Image must be at least 150x150px.", async (value) => {
      if (!value) return true;
      try {
        await validateImageDimensions(value, 150, 150);
        return true;
      } catch {
        return false;
      }
    }),
  bg: yup
    .mixed<any>()
    .notRequired()
    .test("fileType", "Please select an image file.", (value) => {
      if (!value) return true;
      const allowedExtensions = process.env.REACT_APP_IMG_EXT?.split(",").map((ext) =>
        ext.replace(".", "").toLowerCase(),
      );
      const fileExtension = getFileExtension(value.name);
      return allowedExtensions?.includes(fileExtension || "");
    })
    .test("fileSize", "Please select file size less than 2MB.", (value) => {
      if (!value) return true;
      return value.size <= +(process.env.REACT_APP_IMG_SIZE_LIMIT || 524288);
    })
    .test(
      "imageDimensions",
      "Please select a file size with a minimum of 600px by 200px.",
      async (value) => {
        if (!value) return true;
        try {
          await validateImageDimensions(value, 600, 200);
          return true;
        } catch {
          return false;
        }
      },
    ),
});
